import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  root: { display: 'flex' },
  content: {
    left: 287,
    transition: 'left 0.3s ease-out',
  },
  sidebarCollapse: {
    // width: '90%',
    // margin:'0 auto',
    transition: 'left 0.3s ease-out',
    overflowX: 'hidden',
    left: 68
  },
}));
